<div class="header">
  <h2>Administrador general → Destinatarios</h2>
  <app-navegacion></app-navegacion>
</div>
<div class="container">
  <form>
    <div class="form-group">
      <app-generic-select [options]="myOptions" placeholder="Tipo" (selectionChange)="onSelected($event)">
      </app-generic-select>
      <label for="tipo">Tipo</label>
      <select id="tipo" class="form-control" [(ngModel)]="destinatario.tipo" name="tipo">
        <option value="Workgroup">Workgroup</option>
        <option value="Email">Email</option>
        <option value="Chat">Chat</option>
      </select>
    </div>

    <div class="form-group">
      <label for="destinatario">Destinatario</label>
      <input type="text" id="destinatario" class="form-control" [(ngModel)]="destinatario.destinatario"
        name="destinatario" readonly />
    </div>

    <div class="form-group">
      <label for="descripcion">Descripción</label>
      <input type="text" id="descripcion" class="form-control" [(ngModel)]="destinatario.descripcion"
        name="descripcion" />
    </div>

    <div class="form-group">
      <label for="horario">Horario</label>
      <div class="form-row">
        <div class="col">
          <input type="time" id="horarioInicio" class="form-control" [(ngModel)]="destinatario.horarioInicio"
            name="horarioInicio" />
        </div>
        <div class="col">
          <input type="time" id="horarioFin" class="form-control" [(ngModel)]="destinatario.horarioFin"
            name="horarioFin" />
        </div>
      </div>
    </div>

    <!-- Botones para guardar y volver -->
    <button type="button" class="btn btn-secondary" (click)="volver()">
      Volver
    </button>
    <button type="submit" class="btn btn-success">Guardar</button>
  </form>
</div>